import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file-find.dto';
import { ApiUrlPipe } from '@zaoblako/web/shared/pipes/api-url.pipe';
import { FileSizePipe } from '@zaoblako/web/shared/pipes/file-size.pipe';
import { FileTypePipe } from '@zaoblako/web/shared/pipes/file-type.pipe';
import { TruncatePipe } from '@zaoblako/web/shared/pipes/truncate.pipe';

@Component({
  standalone: true,
  selector: 'crm-document-link',
  templateUrl: 'document-link.component.html',
  imports: [CommonModule, FileTypePipe, ApiUrlPipe, FileSizePipe, TruncatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentLinkComponent {
  @Input() public file: FileFindInterface;
  @Input() public created: Date;
  @Input() public isShowFileSize = true;
  @Input() public iconSize = 'text-2xl';
}
